import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { BackfillRunStatus } from '@/graph/run-status';

interface RunStatusLineProps {
  status: BackfillRunStatus;
}

/**
 * Inline progress/outcome line for an async rollup run, shared by the
 * executive and staff-attribution admin dialogs. Worker failures (`failedJobs`)
 * are surfaced distinctly from fan-out enqueue failures (`enqueueFailures`),
 * because the run-level status does not reflect worker outcomes — a run can be
 * "done" with failed rollups.
 */
export const RunStatusLine: FC<RunStatusLineProps> = ({ status }) => {
  const done = status.completedJobs >= status.enqueuedJobs;
  return (
    <Box mt={1}>
      <Typography variant="body2" color="textSecondary">
        Jobs: {status.completedJobs}/{status.enqueuedJobs}
        {done ? ' done' : ' ...'}
        {status.failedJobs > 0 && ` | Failed: ${status.failedJobs}`}
        {status.enqueueFailures > 0 && ` | Not enqueued: ${status.enqueueFailures}`}
        {status.durationMs != null && ` | ${(status.durationMs / 1000).toFixed(1)}s`}
      </Typography>
    </Box>
  );
};

export default RunStatusLine;
